import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { mockLaunches, getUpcomingLaunches, getPastLaunches, getRecentLaunches } from '../services/dataService';
import CountdownTimer from '../components/CountdownTimer';

/**
 * Launch List Page Component
 * Shows upcoming, recent, and past launches
 */
const LaunchList = () => {
  const [filter, setFilter] = useState('all'); // all, upcoming, recent, past
  const upcoming = getUpcomingLaunches();
  const recent = getRecentLaunches();
  const past = getPastLaunches();

  const getFilteredLaunches = () => {
    switch (filter) {
      case 'upcoming':
        return upcoming;
      case 'recent':
        return recent;
      case 'past':
        return past;
      default:
        return mockLaunches;
    }
  };

  const launches = getFilteredLaunches();

  return (
    <div className="container" style={{ paddingTop: '30px' }}>
      <h1 style={{ fontSize: '36px', marginBottom: '30px', textAlign: 'center' }}>
        🚀 Launches
      </h1>

      {/* Filter Tabs */}
      <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginBottom: '30px', flexWrap: 'wrap' }}>
        <button
          onClick={() => setFilter('all')}
          className={filter === 'all' ? 'btn btn-primary' : 'btn btn-secondary'}
        >
          All Launches
        </button>
        <button
          onClick={() => setFilter('upcoming')}
          className={filter === 'upcoming' ? 'btn btn-primary' : 'btn btn-secondary'}
        >
          Upcoming ({upcoming.length})
        </button>
        <button
          onClick={() => setFilter('recent')}
          className={filter === 'recent' ? 'btn btn-primary' : 'btn btn-secondary'}
        >
          Recent ({recent.length})
        </button>
        <button
          onClick={() => setFilter('past')}
          className={filter === 'past' ? 'btn btn-primary' : 'btn btn-secondary'}
        >
          Past ({past.length})
        </button>
      </div>

      <div className="grid">
        {launches.map(launch => (
          <div key={launch.id} className="card">
            <h2 style={{ color: 'var(--highlight-color)', marginBottom: '15px' }}>
              {launch.missionName}
            </h2>
            <p style={{ marginBottom: '10px' }}>
              <strong>Date:</strong> {new Date(launch.launchDate).toLocaleString()}
            </p>
            <p style={{ marginBottom: '10px' }}>
              <strong>Site:</strong> {launch.launchSite}
            </p>
            <p style={{ marginBottom: '10px' }}>
              <strong>Status:</strong> {launch.status}
            </p>
            <p style={{ marginBottom: '10px' }}>
              <strong>Type:</strong> {launch.missionType}
            </p>
            <p style={{ marginBottom: '15px' }}>
              <strong>Payload:</strong> {launch.payloadDetails}
            </p>
            {filter === 'upcoming' && new Date(launch.launchDate) > new Date() && (
              <div style={{ marginBottom: '15px' }}>
                <CountdownTimer targetDate={launch.launchDate} />
              </div>
            )}
            <Link to={`/launches/${launch.id}`} className="btn btn-primary" style={{ display: 'block', textAlign: 'center' }}>
              View Details
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LaunchList;
